module.exports = __webpack_public_path__ + "img/poltorak.4570946d.png";